// base
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

// components
import {
  IsLoadingLayout,
} from '../../components';

import Autocomplete from 'react-autocomplete';

// assets
import './search.scss';
import img_search from '../../assets/images/common/icon-search.png';
import defaultSymbol from '../../assets/images/common/default_symbol.png';

// api
import { searchContract, isContract } from "../../../api";

class Search extends Component {
  state = {
    input : '',
    contracts: [],
    open: false,
    inputFocus: false,
    contract: '',
  };

  search = () => {
    const { input, contract } = this.state;

    if (input) {
      this.setState({
        input: '',
      });

      if (contract) {
        this.props.history.push(`/contract/${contract}`);
      } else if (input.length === 66 ) {
        this.props.history.push(`/transaction/${input}`);
      } else if (input.length === 42) {
        isContract(input).then((res) => {
          if (res.data.isExist) {
            this.props.history.push(`/contract/${input}`);
          } else {
            this.props.history.push(`/account/${input}`);
          }
        }).catch((e) => {
          console.warn(e);
          this.props.history.push(`/account/${input}`);
        });
      } else {
        this.props.history.push(`/blocks/detail/${input}`);
      }
    }
  };

  getContractList = (value) => {
    searchContract(value).then((res) => {
      if (this.state.inputFocus) {
        var contract = '';
        var contracts = res.data;
        if (contracts.length === 1 && contracts[0].name.toLowerCase() === value) {
          contract = contracts[0].address;
        }

        this.setState({
          contracts,
          open: contracts.length > 0,
          contract,
        });
      }
    }).catch(() => {
      this.setState({
        contracts: [],
        open: false,
      });
    });
  }

  inputText = (e) => {
    const { value } = e.target;
    var state = {
      input: value,
      contracts: [],
      open: false,
      inputFocus: true,
      contract: '',
    }

    if (value.length > 1) {
      this.getContractList(value);
      state.contracts.push({ name: '', loading: true });
      state.open = true;
    }

    this.setState(state);
  };

  selectContract = (item) => {
    const { name, address: contract } = item;

    if (name) {
      this.setState({
        input: name,
        contracts: [],
        open: false,
        contract,
      });
    }
  }

  endText = (event) => {
    if (event.keyCode === 13) {
      setTimeout(() => {
        this.search();
      }, 20);
    }

    if (event.keyCode === 27) {
      this.setState({
        open: false,
      });
    }
  };

  closeAutocomplete = () => {
    this.setState({
      open: false,
      inputFocus: false,
    });
  };

  render() {
    window.addEventListener('scroll', () => {
      if (this.state.open) {
        this.setState({ open: false });
      }
    });

    return (
      <article className="search">
        <div className="search_wrapper">
          <span className="search_text">Search</span>
          <Autocomplete
            wrapperProps={{ className: "search_input_wrapper" }}
            value={this.state.input}
            items={this.state.contracts}
            open={this.state.open}
            getItemValue={item => item.name}
            renderItem={(item, selected) =>
              item.loading ?
              <IsLoadingLayout key="loading" isLoading={true} size={20} />
              :
              <div key={item.address} className={`autocomplete_item ${selected ? 'selected' : ''}`}>
                <img src={item.icon ? item.icon : defaultSymbol} alt={item.name}
                     onError={e => e.target.src = defaultSymbol}/>
                <div className="item_desc">
                  <div>{item.name} ({item.symbol})</div>
                  <div className="sub_desc">{item.address}</div>
                  { item.official && <div className="sub_desc">{item.official}</div> }
                </div>
              </div>
            }
            onChange={e => this.inputText(e)}
            onSelect={(v, item) => this.selectContract(item)}
            inputProps={{
              className: "search_input",
              onKeyDown: this.endText,
              onFocus: this.inputText,
              onBlur: this.closeAutocomplete,
            }} />
          <img className="search_img" src={img_search} alt="검색" onClick={this.search} />
        </div>
      </article>
    )
  }
};

export default withRouter(Search);
